const { Modal } = require("antd");

export const ModalSucesso = (titulo = 'Sucesso!', mensagem = '') => {
    Modal.success({
        title: titulo,
        content: mensagem,
        centered: true,
        width: 600
    });
};

export function ModalSucessoBotoesCustomizados(
    {
        titulo,
        conteudo,
        onClickAcao,
        largura = 600,
        centralizado = true,
        labelBotaoOk = "Fechar"
    }) {
    Modal.success({
        title: titulo,
        width: largura,
        content: conteudo,
        onOk: async () => {
            if (onClickAcao) {
                await onClickAcao();
            }
        },
        okText: labelBotaoOk,
        centered: centralizado
    });
}